import { VD_STATE_FLAG, type VdCraftState } from "@act/shared";
import type { Ship } from "../ship/Ship";

/** A craft as an online race sends it (ACT HQ t-492): where it is, how it's turned, how fast, how far round. */
export function craftState(slot: number, ship: Ship): VdCraftState {
  const p = ship.root.position;
  const q = ship.root.rotationQuaternion!;
  const flags =
    (ship.airborne ? VD_STATE_FLAG.airborne : 0) |
    (ship.boostTimer > 0 ? VD_STATE_FLAG.boosting : 0) |
    // Just put back on the road after a fall (the flash starts at 1 and fades).
    (ship.respawnFlash > 0.9 ? VD_STATE_FLAG.respawned : 0) |
    (ship.drifting ? VD_STATE_FLAG.drifting : 0);
  return { slot, x: p.x, y: p.y, z: p.z, qx: q.x, qy: q.y, qz: q.z, qw: q.w, speed: ship.speed, trackT: ship.trackT, flags };
}
